import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgJoin',
  standalone: false,
})
export class SgJoinPipe implements PipeTransform {
  transform(value: Array<any>, delimiter: string = ','): string {
    return value?.join(delimiter);
  }
}

@Pipe({
  name: 'sgSplit',
  standalone: false,
})
export class SgSplitPipe implements PipeTransform {
  transform(value: string, delimiter: string = ','): Array<string> {
    let regex: RegExp;
    if (delimiter.startsWith('/')) {
      const regexLiteral = delimiter.split('/')[1];
      regex = new RegExp(regexLiteral, 'g');
    }
    return value.split(regex ?? delimiter);
  }
}
